<template>
	<div class="site-section interior">
    <section class="hero is-medium is-black is-vcentered">
      <div class="columns is-tablet">
        <div class="column is-one-third is-one-quarter-tablet is-full-mobile">
          <img src="../../assets/hero-daddy-token.png">
        </div>
        <div class="column">
          <div class="hero-body">
            <h1 class="is-size-1 lucky-title">
              FAQ
            </h1>
          </div>
        </div>
      </div>
    </section>
    <section class="body-content">
      <p class="question mt-3 is-size-4">How many NFDaddys are in the collection? </p>
      <p class="answer mt-1 is-size-5">10,000 NFT collection</p>
      <p class="question mt-3 is-size-4">What is the mint price? </p>
      <p class="answer mt-1 is-size-5">0.07 ETH mint price</p>
      <p class="question mt-3 is-size-4">When does Presale start? </p>
      <p class="answer mt-1 is-size-5">October 15, 2021 at 12:00PM ET</p>
      <p class="question mt-3 is-size-4">When does Public Launch Start? </p>
      <p class="answer mt-1 is-size-5">October 18, 2021 at 12:00PM ET</p>
      <p class="question mt-3 is-size-4">How do I get added to the Whitelist? </p>
      <p class="answer mt-1 is-size-5">Join the <a href="https://discord.gg/4gQZYE9NC9" target="_blank">Discord</a> or message us on <a href="https://twitter.com/nfdaddys" target="_blank">Twitter</a> to learn how to get added!  Too many ways to explain here. </p>
    </section>
	</div>
</template>
<script>
/* eslint-disable no-console */
export default {
  name: "FAQ",
  methods: {

  },
};
/* eslint-enable no-console */
</script>
<style scoped>

.answer {
  padding-left: 20px;
}

</style>